<template>
  <Card :title="$t('claims.infoClaims.title')" :header-divider="false">
    <template v-slot:content>
      <p v-html="$t('claims.infoClaims.text')" class="mb-24"></p>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card } from 'de-zurich-ui-library'
</script>

<style scoped lang="scss">
:deep(.card) {
  background: var(--card-background-background-color-claims) !important;
}
</style>
